import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomNumberPipe } from '../../pipes/custom-number.pipe';
import { PipeModule } from '../../pipes/pipe.module';
import { FormRangeDateComponent } from './form-range-date.component';
import { FormRangeNumberComponent } from './form-range-number.component';
import { RangeSliderButtonDirective } from './range-slider-button.directive';
import { RangeSliderComponent } from './range-slider.component';
import { RangeSliderUtils } from './range-slider.utils';

const DECLARATIONS = [
    RangeSliderComponent,
    RangeSliderButtonDirective,
    FormRangeDateComponent,
    FormRangeNumberComponent
];

const IMPORTS = [
    CommonModule,
    ReactiveFormsModule,
    PipeModule
];

const EXPORTS = [
    FormRangeDateComponent,
    FormRangeNumberComponent
];

/**
 * PRIVATE!
 *
 * Use {@link FormsModule}.
 */
@NgModule({
    imports: IMPORTS,
    declarations: DECLARATIONS,
    exports: EXPORTS,
    providers: [RangeSliderUtils, CustomNumberPipe]
})
export class FormRangeSliderModule {
}
